import dynamic from 'next/dynamic'

export const DynamicStudentVerificationSuccessEmailModal = dynamic(
  () => import('.').then((mod) => mod.EmailModal),
  { ssr: false },
)
